import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_card';
export const useEventCardTranslation = (): UseTranslationResponse<'shared', typeof keyPrefix> => useTranslation('shared', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    match_tag: 'Совпадение',
    similarity_event: 'Событие',
    similarity_face: 'Лицо',
    similarity_card: 'Карточка',
    source: 'Источник',
    handler: 'Сценарий',
    event_link: 'Детали события',
    lists: 'Списки',
    face_id: 'ID лица',
    full_name: 'ФИО',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    match_tag: 'Match',
    similarity_event: 'Event',
    similarity_face: 'Face',
    similarity_card: 'Card',
    source: 'Source',
    handler: 'Handler',
    event_link: 'Event details',
    lists: 'Lists',
    face_id: 'Face ID',
    full_name: 'Full name',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    match_tag: 'Correspondência',
    similarity_event: 'Evento',
    similarity_face: 'Face',
    similarity_card: 'Cartão',
    source: 'Fonte',
    handler: 'Manipulador',
    event_link: 'Detalhes do evento',
    lists: 'Listas',
    face_id: 'ID da face',
    full_name: 'Nome completo',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    match_tag: 'Coincidencia',
    similarity_event: 'Evento',
    similarity_face: 'Cara',
    similarity_card: 'Tarjeta',
    source: 'Fuente',
    handler: 'Controlador',
    event_link: 'Detalles del evento',
    lists: 'Listas',
    face_id: 'ID de la cara',
    full_name: 'Nombre completo',
  },
}) as Record<string, unknown>;
